import { EMOJI, emojiInfo } from './emoji-data.js';
export const SKIN_TONES = [
    { tone: 0, label: 'Default skin tone', modifier: '' },
    { tone: 1, label: 'Light skin tone', modifier: '\u{1F3FB}' },
    { tone: 2, label: 'Medium-light skin tone', modifier: '\u{1F3FC}' },
    { tone: 3, label: 'Medium skin tone', modifier: '\u{1F3FD}' },
    { tone: 4, label: 'Medium-dark skin tone', modifier: '\u{1F3FE}' },
    { tone: 5, label: 'Dark skin tone', modifier: '\u{1F3FF}' },
];
const MODIFIERS = /[\u{1F3FB}-\u{1F3FF}]/gu;
const VS16 = '\uFE0F';
/**
 * Puts a skin tone on an emoji that takes one: the modifier goes straight after the first code point
 * (replacing the presentation selector there), so it also works inside ZWJ sequences like 🧑‍💻 and 🙋‍♀️.
 * Emoji that do not take a tone come back unchanged.
 */
export function applyTone(char, tone, takesTone = emojiInfo(stripTone(char))?.tone ?? false) {
    if (!tone || !takesTone)
        return char;
    const modifier = SKIN_TONES[tone]?.modifier ?? '';
    const [first, ...rest] = Array.from(stripTone(char));
    if (!first)
        return char;
    if (rest[0] === VS16)
        rest.shift();
    return first + modifier + rest.join('');
}
/** The emoji without any skin tone (recents keep the tone the person picked; search uses the base). */
export function stripTone(char) {
    return char.replace(MODIFIERS, '');
}
/**
 * Emoji matching a search: names and keywords that start with every word typed, best first (a name
 * that starts with the query, then a word of the name, then a keyword).
 */
export function searchEmoji(query, list = EMOJI, limit = 80) {
    const words = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
    if (!words.length)
        return [];
    const scored = [];
    list.forEach((e, i) => {
        const name = e.name.toLowerCase();
        const nameWords = name.split(/[\s:,-]+/);
        const hay = [...nameWords, ...e.keywords];
        if (!words.every((w) => hay.some((h) => h.startsWith(w))))
            return;
        const q = words.join(' ');
        const score = name.startsWith(q) ? 0 : nameWords.some((n) => n.startsWith(words[0] ?? '')) ? 1 : 2;
        scored.push({ e, score, i });
    });
    return scored
        .sort((a, b) => a.score - b.score || a.i - b.i)
        .slice(0, limit)
        .map((s) => s.e);
}
export const inCategory = (category, list = EMOJI) => list.filter((e) => e.category === category);
/** A label for screen readers ("thumbs up, medium skin tone"); falls back to the emoji itself. */
export function emojiLabel(char) {
    const base = stripTone(char);
    const info = emojiInfo(base);
    const toneMatch = char.match(MODIFIERS);
    const toneLabel = toneMatch ? SKIN_TONES.find((s) => s.modifier === toneMatch[0])?.label.toLowerCase() : undefined;
    return info ? `${info.name}${toneLabel ? `, ${toneLabel}` : ''}` : char;
}
/** Inserts text at the cursor (replacing a selection) and says where the cursor goes after it. */
export function insertAt(text, sel, insert) {
    const start = Math.max(0, Math.min(sel?.start ?? text.length, text.length));
    const end = Math.max(start, Math.min(sel?.end ?? start, text.length));
    return { text: text.slice(0, start) + insert + text.slice(end), cursor: start + insert.length };
}
//# sourceMappingURL=emoji.js.map